<template>
	<v-touch @pan id="app" :class="'app-' + app.user.color">
		
		<game />
		<options></options>
		<about></about>

		<v-touch v-if="!game.status" @tap="start_game()" class="screen home">
			
			<div class="logo">
				<div class="cards">
					<card :card="{ value: 7 }" />
					<card :card="{ value: 1 }" />
					<card :card="{ value: 4 }" />
					<card :card="{ value: 3 }" />
					<card :card="home_card" />
				</div>
				<div class="text">Cards +1</div>
			</div>
			
			<div class="hint">{{ texts[lang].tap_to_start }}</div>
		</v-touch>

		<language v-if="app.user.first_times.lang"></language>

	</v-touch>
</template>

<script>
import { mapGetters } from 'vuex'
import Card from './components/game/Card'
import Game from './components/Game'
import Options from './components/Options'
import About from './components/About'
import Language from './components/Language'

export default {
	name: 'App',
	data: function() {
		return {
			home_card: {
				type: 'logo'
			}
		}
	},
	computed: Object.assign(mapGetters([ 'texts', 'lang', 'app', 'game' ]), {
		
	}),
	methods: {
		start_game: function() {
			this.$store.dispatch('start_game')
		}
	},
	mounted: function() {
		this.$store.dispatch('load_data')
	},
	components: {
		Card, Game, Options, Language, About
	}
}
</script>

<style lang="stylus">
// @import url('https://fonts.googleapis.com/css?family=Carter+One');
@import './assets/css/app'

@font-face {
	font-family: 'Carter One';
	font-style: normal;
	font-weight: 400;
	src: local('Carter One'), local('CarterOne'), url(./assets/fonts/CarterOne.woff2) format('woff2');
	unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

*
	margin 0
	padding 0
	position relative
	box-sizing border-box
	cursor default
	user-select none
	
html, body, #app
	height 100%
	width 100%
	overflow hidden

body
	font-family 'Carter One', Arial
	font-size 16px
	color darken(dark, 15%)
	background #f8f7f3

#app
	background dark
	// background url(./assets/img/bg.png)
	// background-size cover
	// background-position center
	&.app-green
		background-color app_green
		.game .game-header .score .score-nb
			background-color app_green
			box-shadow 0 0 16px 16px app_green
		.game
			.game-content
				box-shadow 0 -2px 0 2px darken(app_green, 10%)
				.life
					box-shadow 0 -2px 0 2px darken(app_green, 10%)
					.dot
						background-color darken(app_green, 15%)
	&.app-brown
		background-color app_brown
		.game .game-header .score .score-nb
			background-color app_brown
			box-shadow 0 0 16px 16px app_brown
		.game
			.game-content
				box-shadow 0 -2px 0 2px darken(app_brown, 10%)
				.life
					box-shadow 0 -2px 0 2px darken(app_brown, 10%)
					.dot
						background-color darken(app_brown, 15%)
	&.app-purple
		background-color app_purple
		.game .game-header .score .score-nb
			background-color app_purple
			box-shadow 0 0 16px 16px app_purple
		.game
			.game-content
				box-shadow 0 -2px 0 2px darken(app_purple, 10%)
				.life
					box-shadow 0 -2px 0 2px darken(app_purple, 10%)
					.dot
						background-color darken(app_purple, 15%)

.screen
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	height 100%
	width 100%
	
.home
	.logo
		position absolute
		top 55%
		left 50%
		transform translate3D(-50%, -50%, 0)
		.text
			font-size 32px
			color #fff
			text-align center
			line-height 34px
		.cards
			position absolute
			left 50%
			top -110px
			width card_width
			height (card_height)
			background red
			transform translate3D(-50%, 0, 0)
			display flex
			flex-direction column
			background alpha(#000, 15%)
			border-radius 4px
			box-shadow 0 0 0 6px alpha(#000, 15%)
			.card
				position absolute
				left 0
				top 0
				&:nth-child(1)
					transform translate3D(0, -2px, 0)
				&:nth-child(2)
					transform translate3D(0, -6px, 0)
				&:nth-child(3)
					transform translate3D(0, -10px, 0)
				&:nth-child(4)
					transform translate3D(0, -14px, 0)
				&:nth-child(5)
					transform translate3D(0, -18px, 0)
	.hint
		position absolute
		left 0
		right 0
		bottom 24px
		text-align center
		color light
		opacity 0.5
		animation hint 4s infinite

@keyframes hint {
	0% {
		opacity 0.5
		transform scale(1)
	}
	40% {
		transform scale(1.1)
		opacity 1
	}
	60% {
		opacity 1
		transform scale(1.1)
	}
	100% {
		opacity 0.5
		transform scale(1)
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue